import { render, staticRenderFns } from "./my_win.vue?vue&type=template&id=4221cc53&scoped=true&"
import script from "./my_win.vue?vue&type=script&lang=js&"
export * from "./my_win.vue?vue&type=script&lang=js&"
import style0 from "./my_win.vue?vue&type=style&index=0&id=4221cc53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221cc53",
  null
  
)

export default component.exports